/**
 * Stable CSS class names for E2E — Payment logs page.
 */
export const PLOG = {
    page: 'payment-logs-page',
    breadcrumbSection: 'payment-logs-page__breadcrumb-section',

    searchSection: 'payment-logs-page__search-section',
    searchPaper: 'payment-logs-page__search-paper',
    searchSelect: 'payment-logs-page-input--select-document-type',
    searchInput: 'payment-logs-page-input--text-search',
    searchButton: 'payment-logs-page-input--button-search',

    progressSection: 'payment-logs-page__progress-section',
    progressBar: 'payment-logs-page__progress-bar',

    gridSection: 'payment-logs-page__grid-section',
    dataGridWrap: 'payment-logs-page__data-grid-wrap',
    noRecordWrap: 'payment-logs-page__no-record-wrap',

    cellDateTime: 'payment-logs-page__cell-date-time',
    cellDescription: 'payment-logs-page__cell-description',
    cellStatus: 'payment-logs-page__cell-status',
    statusIconSuccess: 'payment-logs-page__status-icon--success',
    statusIconError: 'payment-logs-page__status-icon--error',
    statusIconWarning: 'payment-logs-page__status-icon--warning',

    cellDetailWrap: 'payment-logs-page__cell-detail-wrap',
    cellDetailButton: 'payment-logs-page-input--button-detail',
    drawerPaper: 'payment-logs-page__drawer-paper',
} as const;

export const plogCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

